import * as React from 'react';
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import TextInput from './TextInput';
import LabeledData from './LabeledData';
import { getPolicyNumberPreview } from 'helpers/policyNumberFormat';

interface Props {
    policyNumberFormat: string | undefined | null;
    startingPolicyNumber: number | undefined | null;
    onPolicyNumberFormatChange: (value: string) => void;
    onStartingPolicyNumberChange: (value: number | undefined) => void;
    disabled?: boolean;
    size?: 'small' | 'medium';
    fullWidth?: boolean;
    startingPolicyNumberError?: string;
}

/**
 * Renders the Policy Number Format input, Starting Policy Number input, and a live
 * preview. Intended to be placed inside an existing <Grid container>.
 */
const PolicyNumberFields: React.FunctionComponent<Props> = ({
    policyNumberFormat,
    startingPolicyNumber,
    onPolicyNumberFormatChange,
    onStartingPolicyNumberChange,
    disabled = false,
    size = 'medium',
    fullWidth = true,
    startingPolicyNumberError,
}) => (
    <>
        <Grid xs={12} sm={6}>
            <TextInput
                title="Policy Number Format"
                fullWidth={fullWidth}
                size={size}
                disabled={disabled}
                value={policyNumberFormat || ''}
                onChange={(e) => onPolicyNumberFormatChange(e.target.value)}
            />
            <Box marginLeft="8px">
                <Typography variant="caption" color="text.secondary">
                    Variables: <code>{'<$baseNumber,N>'}</code> and <code>{'<$renewalNumber,N>'}</code> where N is the
                    digit width. Example: <code>{'LRS<$baseNumber,6>-<$renewalNumber,2>'}</code>
                </Typography>
            </Box>
        </Grid>

        <Grid xs={12} sm={6}>
            <TextInput
                title="Starting Policy Number"
                fullWidth={fullWidth}
                size={size}
                disabled={disabled}
                value={startingPolicyNumber ?? ''}
                errorMessage={startingPolicyNumberError}
                onChange={(e) =>
                    onStartingPolicyNumberChange(e.target.value !== '' ? parseInt(e.target.value, 10) : undefined)
                }
            />
        </Grid>

        {(policyNumberFormat || startingPolicyNumber != null) && (
            <Grid xs={12}>
                <LabeledData
                    title="Example Policy Number"
                    value={getPolicyNumberPreview(policyNumberFormat, startingPolicyNumber) || '—'}
                />
            </Grid>
        )}
    </>
);

export default PolicyNumberFields;
